import config from '../config/index'
import request from './request';
// const API_HOST = "http://localhost:8081";
// const API_HOST = "https://innovaapi.aminer.cn/sms";
// const API_HOST = "http://192.168.6.221:8281"
const API_HOST = config.apiPath;

const getAuthorization = () => {
  let accessToken = localStorage.getItem("accessToken");
  if (accessToken === "undefined" || accessToken === "null") {
    accessToken = null;
  }
  return accessToken ? `Bearer ${accessToken}` : null;
};

// 校验token是否过期，过期则重新进行飞书登录，否则直接进入首页
export async function checkToken() {
    // const accessToken = localStorage.getItem('accessToken');
    const startTime = localStorage.getItem('loginTime')
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    // console.log("startTime=", startTime)
    if (startTime && user.id) {
        // 设置30天的过期时间
        if (new Date().getTime() - startTime > 30 * 24 * 60 * 60 * 1000) {
            return false
        } else {
            return true
        }
    } else {
        return false
    }
}

// 飞书登录认证
export async function feishuAuth(data) {
    const res = await request.post("/api/v1/user/login", data);
    return res.data;
}

// 获取临时账号
export async function getCasualUsers(data) {
    const res = await request.post("/api/v1/dinner/casuals/get", data);
    return res.data;
}

// 新增临时账号
export async function addCasualUser(data) {
    const res = await request.post("/api/v1/dinner/casual", data);
    return res.data;
}

// 删除临时账号
export async function deleteCasualUser(data) {
    const res = await request.post("/api/v1/dinner/casual/delete", data);
    return res.data;
}

export function userId() {
    // return localStorage.getItem("aminer_user_id");
    const user = JSON.parse(localStorage.getItem('user') || '{}') || {}
    return user.id
}

export function userPwd() {
    return localStorage.getItem("aminer_user_pwd") || "";
}

export function isCasual() {
    return localStorage.getItem("aminer_user_casual") == 'true';
}

export function logout() {
    // localStorage.removeItem("aminer_user_id");
    localStorage.removeItem('accessToken')
    localStorage.removeItem('user')
    localStorage.removeItem('loginTime')
    document.cookie = null;
}

export async function searchUser(name, company) {
    let url = API_HOST + `/api/v1/employees/search?text=${name}&company=${company}`;
    let res = await fetch(url, {
        headers: {
            "Authorization": getAuthorization()
        }});
    return res.json();
}

export async function login(id, password) {
    localStorage.setItem("aminer_user_id", id);
    localStorage.setItem("aminer_user_pwd", password);
    localStorage.removeItem("aminer_user_casual");
    document.cookie = id;
    let url = API_HOST + `/api/v1/user/login`
    let res = await fetch(url, {
        method: 'POST',
        headers: {
            "content-type": "application/json"  
        },
        body: JSON.stringify({ id, password})
    });
    return res.json();
}

export async function signin(name, gender, company) {
    let url = API_HOST + `/api/v1/user/signin`;
    return new Promise((resolve, reject) => {
        fetch(url, {
            method: 'POST',
            headers: {
                "content-type": "application/json",
                "Authorization": getAuthorization()
            },
            body: JSON.stringify({
                name,
                gender,
                company,
                avatar: gender == '女' ? "https://ftp.aminer.cn/staff-management/avatar/female.jpg" : "https://ftp.aminer.cn/staff-management/avatar/male.jpg"
            })
        }).then(res => res.json()).then(data => {
            if(data && data.code == 0) {
                localStorage.setItem("aminer_user_id", data.data.id);
                localStorage.removeItem("aminer_user_pwd");
                localStorage.removeItem("aminer_user_casual");
            }
            resolve(data);
        })
    })
}

export async function setPassword(id, password, old_password="") {
    localStorage.setItem("aminer_user_id", id);
    localStorage.setItem("aminer_user_pwd", password);
    let url = API_HOST + `/api/v1/user/password`
    let res = await fetch(url, {
        method: 'POST',
        headers: {
            "content-type": "application/json",
            "Authorization": getAuthorization()
        },
        body: JSON.stringify({ id, password, old_password})
    });
    return res.json();
}

export async function requestDays(start, len, company, id) {
    let url = API_HOST + `/api/v1/dinner/days`;
    let res = await fetch(url, {
        method: 'POST',
        headers: {
            "content-type": "application/json",
            "Authorization": getAuthorization()
        },
        body: JSON.stringify({
            user: id || userId(),
            start,
            len,
            company
        })
    })
    return res.json()
}

export async function requestOrder(date, selected, locations, id) {
    let url = API_HOST + `/api/v1/dinner/order`;
    let res = await fetch(url, {
        method: 'POST',
        headers: {
            "content-type": "application/json",
            "Authorization": getAuthorization()
        },
        body: JSON.stringify({
            user: id,
            date,
            selected,
            locations
        })
    })
    return res.json()
}

export async function requestStatistics(date, company) {
    let url = API_HOST + `/api/v1/dinner/statistics?date=${date}&company=${company}`;
    
    let res = await fetch(url, {
        headers: {
            "Authorization": getAuthorization()
        }})
    return res.json();
}

export async function requestList(date, company) {
    let url = API_HOST + `/api/v1/dinner/list?date=${date}&ckey=${company}`;
    let res = await fetch(url, {
        headers: {
            "Authorization": getAuthorization()
        }})
    return res.json();
}

export async function requestList2(date, company) {
    let url = API_HOST + `/api/v1/dinner/list2?date=${date}&ckey=${company}`;
    let res = await fetch(url, {
        headers: {
            "Authorization": getAuthorization()
        }})
    return res.json();
}

export async function requestComments(company, page, size) {
    let url = API_HOST + `/api/v1/dinner/comments?company=${company}&page=${page}&size=${size}`;
    let res = await fetch(url, {
        headers: {
            "Authorization": getAuthorization()
        }})
    return res.json();
}

export async function requestAddComment(text, anonymous) {
    let url = API_HOST + `/api/v1/dinner/comment`;
    let res = await fetch(url, {
        method: 'POST',
        headers: {
            "content-type": "application/json",
            "Authorization": getAuthorization()
        },
        body: JSON.stringify({ 
            user: userId(),
            anonymous,
            text
        })
    })
    return res.json();
}

export async function requestCasualLogin(params) {
    let url = API_HOST + `/api/v1/dinner/casual`;
    let res = await fetch(url, {
        method: 'POST',
        headers: {
            "content-type": "application/json",
            "Authorization": getAuthorization()
        },
        body: JSON.stringify(params)
    });
    let data = await res.json()
    if(data.code == 0 && data.data) {
        localStorage.setItem("aminer_user_id", data.data.id);
        localStorage.setItem("aminer_user_casual", "true");
        document.cookie = data.data.id;
    }
    return new Promise(resolve => resolve(data));
}

// 新增历史会议订餐
export async function addMeetingOrder(data) {
    const res = await request.post("/api/v1/dinner/meeting", data);
    return res.data;
}

// 获取历史会议订餐列表
export async function getMeetingOrderList(data) {
    const res = await request.get("/api/v1/dinner/meeting", data);
    return res.data;
}

// 修改历史会议订餐
export async function updateMeetingOrder(data) {
    const res = await request.post("/api/v1/dinner/meeting/update", data);
    return res.data;
}

// 删除历史会议订餐
export async function deleteMeetingOrder(data) {
    const res = await request.post("/api/v1/dinner/meeting/delete", data);
    return res.data;
}